<script setup lang="ts">
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import { useRouter } from 'vue-router';

interface Props {
  visible: boolean;
}

defineProps<Props>();
const emit = defineEmits<{
  'update:visible': [value: boolean];
  'dismiss': [];
}>();

const router = useRouter();

function goToCheckin() {
  emit('update:visible', false);
  router.push('/checkin/self');
}

function dismiss() {
  emit('update:visible', false);
  emit('dismiss');
}
</script>

<template>
  <Dialog
    :visible="visible"
    @update:visible="emit('update:visible', $event)"
    modal
    header="Don't forget your weekly check-in! 📝"
    :style="{ width: '30rem' }"
  >
    <div class="flex flex-col gap-4">
      <p class="text-lg">
        🎉 Great job submitting your Friday pulse!
      </p>
      <p>
        While you're at it, how about submitting your weekly self check-in? It only takes a moment to reflect on your week.
      </p>
      <div class="flex justify-end gap-2 mt-4">
        <Button
          label="Maybe Later"
          severity="secondary"
          outlined
          @click="dismiss"
        />
        <Button
          label="Fill Check-in Now"
          severity="primary"
          icon="pi pi-arrow-right"
          @click="goToCheckin"
        />
      </div>
    </div>
  </Dialog>
</template>
